import { IconAccessLog, IconDiary, IconInfo, IconLiveCaptions, IconManagerSIP, IconManagerSystem, IconMeetingSchedule, IconMonitor, IconOrganization, IconPhonebook, IconRecording, IconRole, IconUser, IconWB } from 'assets/sidebar'
import IconMemberManagemet from 'assets/sidebar/IconMemberManagemet'
import IconPackageManagement from 'assets/sidebar/IconPackageManagement'
import { IconHistoryPage } from 'components/common/IconCommon'
import { URL_LANDING_PAGE } from 'constants/api'
import { ICON } from 'constants/common'
import { FUNCTIONS } from 'constants/roles'
import { useNavigate } from 'react-router-dom'
import { goToLandingPage } from 'utils/functions/common'

export const ROLE_LIST_MENU = {
    ADMIN: 'ADMIN',
    GUEST: 'GUEST'
}

const LIST_MENU = [
    {
        name: 'sidebar.meetingCalendar',
        path: '/manager-meeting',
        icon: <IconMeetingSchedule status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED' 
    },
    {
        name: 'sidebar.recordings',
        path: '/manager-recordings',
        icon: <IconRecording status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.whiteboard',
        path: '/manager-whiteboard',
        icon: <IconWB status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.live-captions',
        path: '/live-captions',
        icon: <IconLiveCaptions status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.access',
        path: '/access-log',
        icon: <IconAccessLog status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.ADMIN,
        rolev2: FUNCTIONS.MANAGE_SYSTEM_LOG_VIEW
    },
    {
        name: 'sidebar.phonebook',
        path: '/phonebook',
        icon: <IconPhonebook status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.organization',
        path: '/organization',
        icon: <IconOrganization status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.users',
        path: '/manager-users',
        icon: <IconUser status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.ADMIN,
        rolev2: FUNCTIONS.MANAGE_USER_VIEW
    },
    {
        name: 'sidebar.managerRoles',
        path: '/manager-roles',
        icon: <IconRole status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.ADMIN,
        rolev2: [FUNCTIONS.MANAGE_ROLE_VIEW, FUNCTIONS.MANAGE_FUNCTION_VIEW]
    },
    {
        name: 'sidebar.managerSystem',
        path: '/manager-systems',
        icon: <IconManagerSystem status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.ADMIN,
        rolev2: FUNCTIONS.MANAGE_SYSTEM_PARAMETER_VIEW
    },
    {
        name: 'sidebar.managerDiary',
        path: '/manager-diary',
        icon: <IconDiary status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.ADMIN,
        rolev2: FUNCTIONS.MANAGER_CONFIG_SYSTEM
    },
    {
        name: 'sidebar.managerSip',
        path: '/manager-user-sip',
        icon: <IconManagerSIP status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.ADMIN,
        rolev2: FUNCTIONS.MANAGE_SIP_ACCOUNT_VIEW
    },
    {
        name: 'sidebar.monitor',
        path: '/meeting-monitor',
        icon: <IconMonitor status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.ADMIN,
        rolev2: FUNCTIONS.MANAGE_MEETING_MONITOR_VIEW
    },
    {
        name: 'breadcrumbs.history',
        path: '/history',
        icon: <IconHistoryPage status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.managerPackage',
        path: '/service-package-management',
        icon: <IconPackageManagement status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.managerMember',
        path: '/member-management',
        icon: <IconMemberManagemet status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
    {
        name: 'sidebar.info',
        path: URL_LANDING_PAGE,
        icon: <IconInfo status={ICON.STATUS.DEFAULT} />,
        role: ROLE_LIST_MENU.GUEST,
        rolev2: 'NO_NEED'
    },
]

const useMenuPage = () => {

    const navigate = useNavigate()

    const handleNavigate = (path) => path === URL_LANDING_PAGE ? goToLandingPage() : navigate(path)

    return {
        listMenu: LIST_MENU,
        handleNavigate
    }
}

export default useMenuPage